module.exports = __webpack_public_path__ + "static/media/featured-stone-active.82166505.svg";